import axios from 'axios'

const token = localStorage.getItem('_token')
const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {'Authorization': 'Bearer ' + token},
    timeout: 10000
});

export default api